export function backScrollBody() {
	const refElement = document.getElementById('scroll-ref')
	if (!refElement) return
	refElement.removeAttribute('style')
}
